import React, { useState } from 'react';
import Filter from '@helpers/Filter';
import Default from './Default'
import AddCard from './AddCard'
import './index.module.less'

const AppDownload: React.FC = () => {
  const [query] = useState<{ type?: 'addCard' }>(Filter.getUrlParams(['type']))

  if(query.type === 'addCard') {
    return <AddCard />
  }

  return <Default />
}

export default AppDownload
